import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ProfileService } from '../../profile.service';

@Component({
  selector: 'mmb-web-app-add-mission-modal',
  templateUrl: './add-mission-modal.component.html',
  styleUrls: ['./add-mission-modal.component.scss']
})
export class AddMissionModalComponent implements OnInit {
  @Output() addSuccess: EventEmitter<string> = new EventEmitter<string>();
  @Output() closed: EventEmitter<any> = new EventEmitter<any>();
  @Input() mission: string;
  @Input() isEditMode: boolean;

  constructor(public modal: NgbActiveModal, private profileService: ProfileService) { }

  ngOnInit() {
    // Ensure user profile is loaded (needed for credential uuid in updateUserCredentials)
    this.profileService.getUserProfile().subscribe();
  }

  addMission() {
    if (this.mission == null || (this.mission ?? '').trim() === '') {
      return;
    }
    // Only send the changed field - sending the full credentials object causes
    // ValidationError when nested objects (e.g. compensation_currency_target) are
    // sent as dicts instead of pk values.
    this.profileService.updateUserCredentials({ mission: this.mission }).subscribe((response) => {
      this.modal.close();
    });
  }

  onClose() {
    this.closed.emit();
  }
}
